import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useQuery } from "react-query";
import { BACKEND_DOMAIN, QUERY_STALE_TIME } from "utils/constants";
import { buildRequestHeaders, showMutationAlert } from "utils/helpers";
 
 export const documentsQueryKey = ["documents"];
 
 const useQueryListDocuments = (buildingModelUid: string) => {
     const alert = useAlert();
     const accessToken = useAccessToken();
     const URL =`${BACKEND_DOMAIN}/buildings/${buildingModelUid}/documents`;

     return useQuery<DocumentResponse[], Error>({
         queryKey: [...documentsQueryKey, buildingModelUid],
         queryFn: async () => {
             const response = await fetch(URL, {
                 method: "GET",
                 headers: buildRequestHeaders(accessToken),
             });
             if (!response.ok) {
                 throw new Error(`Error ${response.status}`);
             }
             return response.json();
         },
         onError: (error) => {
             showMutationAlert(error, alert);
         },
         staleTime: QUERY_STALE_TIME,
     });
 };
 
 export default useQueryListDocuments;
